import React from "react";
import { InputDefaultProps } from "../../types";

function InputDefault({
  onChange,
  value,
  label,
  id,
  name,
  className = "",
  placeholder,
  type = "text",
  required = false,
  maxLength,
  disabled,
  colorLabel,
  classNameInput = "",
}: InputDefaultProps) {
  return (
    <div className={className}>
      <label
        htmlFor={id || name || "input"}
        className="mb-2.5 block text-black dark:text-white"
      >
        {label}
      </label>
      <input
        id={id}
        name={name}
        type={type}
        maxLength={maxLength}
        disabled={disabled}
        onChange={onChange}
        value={value}
        required={required}
        style={{
          backgroundColor: type === "color" ? (value as string) : undefined,
        }}
        className={`w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary text-black dark:text-white ${classNameInput}`}
        placeholder={placeholder}
      />
    </div>
  );
}

export default InputDefault;
